module.exports = __webpack_public_path__ + "img/pvc_expomoda_0005_dark_grey.2ad949b8.jpg";